import "picturefill";
import "lazysizes";

import { ViewportHelper } from "General/global-js/ViewportHelper";
import { AdditionalHelper } from "General/global-js/AdditionalHelper";
import { StickyFooter } from "General/global-js/StickyFooter";
import { FeedbackHelper } from "General/global-js/FeedbackHelper";

window.addEventListener('load', function () {
    // Viewport Helper
    ViewportHelper();
    // Additional Helper
    AdditionalHelper();
    // Sticky Footer
    StickyFooter();
    // Feedback Helper
    FeedbackHelper();
});

var resizeTimer;

$(window).on("resize", function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    StickyFooter();
    ViewportHelper();
  }, 150);
});
